'use strict';

const filterParentModel = require('od-modules/models/accommodation_filter');

module.exports = Odigeo.Model.extend(filterParentModel).extend({
    filterMetadataPath: 'accommodationFiltersMetadata.categoryMetadata',
    filterStatusPath: 'accommodationSearchResultsMetadata.categoryFilterModel',

    init() {
        this.on('change:items', this.cleanItems);
    },

    getRequestCategoryFilter(category) {
        const selectedItems = Odigeo._.clone(this.get('selectedItems')) || [];

        return Odigeo._.contains(selectedItems, category) ? Odigeo._.without(selectedItems, category) : selectedItems.concat(category);
    },

    cleanItems() {
        this.set('items', Odigeo._.omit(this.get('items'), '0'), {silent: true});
    },
});
